/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Reducer";
import { getNegotiationActions } from "../../../redux/Action/Action";
import CustomCard from "../../../components/CustomCard/CustomCard";
interface CardData {
  id: string;
  title: string;
  description: string;
  relatedPhase: string;
  flag: string;
  actionType: any;
  isTrending: any;
  isMostSelected: any;
  avgRating: any;
  status: boolean;
  preselected: boolean;
  inputText: string;
  isCardSelected?: boolean;
}
interface NegotiationRoundsProps {
  onCardSelect: (selectedActionTilesMap: CardData[]) => void;
  setSelectedActionTilesMap: any;
  selectedActionTilesMap: CardData[];
  RoundName: string;
  inputTexts: { [RoundName: string]: { [cardId: string]: string } };
  setInputText: React.Dispatch<React.SetStateAction<{ [RoundName: string]: { [cardId: string]: string } }>>;
  ParentDependecyMap: Record<string, string>;
  deselectedCardIds: Set<string>;
  setDeselectedCardIds: React.Dispatch<React.SetStateAction<Set<string>>>;
}

const NegotiationRounds = ({
  onCardSelect,
  selectedActionTilesMap,
  setSelectedActionTilesMap,
  RoundName,
  inputTexts,
  setInputText,
  ParentDependecyMap,
  deselectedCardIds,
  setDeselectedCardIds
}: NegotiationRoundsProps) => {
  const [cardData, setCardData] = useState<CardData[]>([]);
  const dispatch = useDispatch();
  const sampleCardss = useSelector((state: RootState) => state.negotiationActions.negotiationActions);
  const powerPositionData = useSelector((state: RootState) => state.powerPosition.powerPosition);
  const salesRepData = useSelector((state: RootState) => state.salesRepClassification.classificationType);
  const ReduxSelectedCards = useSelector((state: RootState) => state?.selectedActionTiles?.SelectedActionTilesData) || {};
  const preparationRoundSelectedCards = Object.entries(ReduxSelectedCards)
    .filter(([key]) => key.startsWith("Preparation"))
    .flatMap(([, cards]) => cards);
  useEffect(() => {
    dispatch(getNegotiationActions());
  }, [RoundName]);
  useEffect(() => {
    if (cardData.length === 0) return;
    preparationRoundSelectedCards.forEach((prepCard: any) => {
      const dependentCardId = ParentDependecyMap[prepCard.id];
      if (dependentCardId) {
        const isDependentCardSelected = selectedActionTilesMap.some((c: CardData) => c.id === dependentCardId);
        const isDependentCardDeselected = deselectedCardIds.has(dependentCardId);
        // Select dependent card if not selected and not deselected
        if (!isDependentCardSelected && !isDependentCardDeselected) {
          const dependentCard = cardData.find(card => card.id === dependentCardId);
          if (dependentCard) {
            const updatedSelectedCards = [...selectedActionTilesMap, dependentCard];
            setSelectedActionTilesMap(updatedSelectedCards);
            onCardSelect(updatedSelectedCards);
          }
        }

      }
    });
  }, [ReduxSelectedCards, cardData, deselectedCardIds]);
  useEffect(() => {
    if (sampleCardss.length > 0) {
      const filteredCards = sampleCardss.filter((item: any) => {
        const isNegoRound = item.relatedPhase === "Negotiation rounds" && item.status === true;
        const isDependant = powerPositionData === "Dependent" && item.title === "Threaten with auctions / tender";
        const isWeak = powerPositionData === "Inferior" && ["Challenge your partner's competence to make decisions", "Threaten with auctions / tender", "Play friendly ultimatum"].includes(item.title);
        const isRationalist = salesRepData === "Rationalist" && ["Challenge the facts", "Challenge your partner's competence to make decisions"].includes(item.title);
        const isPerformer = salesRepData === "Performer" && item.title === "Challenge the facts";
        const isOptimizer = salesRepData === "Optimizer" && item.title === "Challenge your partner's competence to make decisions";
        return isNegoRound && !(isDependant || isWeak || isRationalist || isPerformer || isOptimizer);
      });
      const formattedCards: CardData[] = filteredCards.map((item: any) => ({
        ...item,
        inputText: "",
      }));
      setCardData(formattedCards);
    }
  }, [sampleCardss]);

  useEffect(() => {
    if (cardData.length === 0) return;
    const hasSavedSelections = selectedActionTilesMap?.length > 0;

    if (!hasSavedSelections) {
      const preselectedCards = cardData.filter(card => card.preselected);
      if (preselectedCards.length > 0) {
        setSelectedActionTilesMap(preselectedCards);
        onCardSelect(preselectedCards);
      }
    }
  }, [cardData]);

  const handleCardClick = (cardId: string) => {
    const dependentCardId = ParentDependecyMap[cardId];
    const isSelected = selectedActionTilesMap.some(card => card.id === cardId);
    let newSelectedCards = [...selectedActionTilesMap];
    if (isSelected) {
      newSelectedCards = newSelectedCards.filter(card => card.id !== cardId && card.id !== dependentCardId);
      setDeselectedCardIds(prev => new Set([...prev, cardId, dependentCardId]));
    } else {
      const card = cardData.find(c => c.id === cardId);
      const dependentCard = cardData.find(c => c.id === dependentCardId);
      if (card) {
        const inputText = inputTexts?.[RoundName]?.[cardId] || "";
        newSelectedCards.push({ ...card, inputText });
      }
      if (dependentCard) {
        const inputText = inputTexts?.[RoundName]?.[dependentCardId] || "";
        newSelectedCards.push({ ...dependentCard, inputText });
      }
      // Clear deselectedCardIds for these card
      setDeselectedCardIds(prev => {
        const updated = new Set(prev);
        updated.delete(cardId);
        updated.delete(dependentCardId);
        return updated;
      });
    }
    setSelectedActionTilesMap(newSelectedCards);
    onCardSelect(newSelectedCards);
  };

  const handleInputChange = (cardId: string, value: string) => {
    const updatedCards = selectedActionTilesMap.map(card =>
      card.id === cardId ? { ...card, inputText: value } : card
    );
    setSelectedActionTilesMap(updatedCards);
    onCardSelect(updatedCards);
  };
  return (
    <div className="negoRound-responsive-grid">
      {cardData.map(card => (
        <div key={card.id} onClick={() => handleCardClick(card.id)} className="displayCards">
          <CustomCard
            id={card.id}
            title={card.title}
            description={card.description}
            flag={card.flag}
            actionType={card.actionType}
            isTrending={card.isTrending}
            isMostSelected={card.isMostSelected}
            avgRating={card.avgRating}
            inputText={selectedActionTilesMap.find(obj => obj.id === card.id)?.inputText ?? ""}
            onInputChange={value => handleInputChange(card.id, value)}
            isCardSelected={selectedActionTilesMap.some(obj => obj.id === card.id)}
          />
        </div>
      ))}
    </div>
  );
};
export default NegotiationRounds;